import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

const q = (path) => async () => (await api.get(path)).data;

export const useAdminOverview = () => useQuery({ queryKey: ["admin", "overview"], queryFn: q("/admin/overview") });
export const useAdminProgrammes = () => useQuery({ queryKey: ["admin", "programmes"], queryFn: q("/admin/programmes") });
export const useAdminApplications = (params = {}) => {
  const qs = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v))).toString();
  return useQuery({ queryKey: ["admin", "applications", qs], queryFn: q(`/admin/applications${qs ? `?${qs}` : ""}`) });
};
export const useAdminTrials = (status) =>
  useQuery({ queryKey: ["admin", "trials", status || "all"], queryFn: q(`/admin/trials${status ? `?status=${status}` : ""}`) });
export const useAdminCheckins = (trialId) =>
  useQuery({ queryKey: ["admin", "checkins", trialId], queryFn: q(`/admin/trials/${trialId}/checkins`), enabled: !!trialId });
export const useAdminStories = (status) =>
  useQuery({ queryKey: ["admin", "stories", status], queryFn: q(`/admin/stories?status=${status}`) });
export const useTestShowcase = () =>
  useQuery({ queryKey: ["admin", "test-showcase"], queryFn: q("/admin/test-showcase") });

export function useAdminMutation(fn, onSuccess) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (data, vars) => {
      qc.invalidateQueries({ queryKey: ["admin"] });
      qc.invalidateQueries({ queryKey: ["programmes"] });
      qc.invalidateQueries({ queryKey: ["stories"] });
      onSuccess?.(data, vars);
    },
  });
}

export const adminApi = {
  createProgramme: (body) => api.post("/admin/programmes", body).then((r) => r.data),
  updateProgramme: ({ id, body }) => api.put(`/admin/programmes/${id}`, body).then((r) => r.data),
  setProgrammeStatus: ({ id, status }) => api.patch(`/admin/programmes/${id}/status`, { status }).then((r) => r.data),
  setApplicationStatus: ({ id, status, note }) => api.patch(`/admin/applications/${id}/status`, { status, note }).then((r) => r.data),
  dispatch: ({ id, carrier, tracking_number }) => api.patch(`/admin/trials/${id}/dispatch`, { carrier, tracking_number }).then((r) => r.data),
  moderateStory: ({ id, status, note }) => api.patch(`/admin/stories/${id}`, { status, note }).then((r) => r.data),
};

export const errorMessage = (e) => e?.response?.data?.detail || "Something went wrong. Please try again.";
export const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const inputCls = "w-full bg-cream border border-forest/20 px-3.5 py-2.5 text-sm text-charcoal focus:border-forest outline-none transition-colors";
